import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IStep } from "../interface"
import { 
    ButtonContainer, 
    InputContainer, 
    RowForButton, 
    RowForInput, 
    TitleField 
} from "./style"
import * as Yup from "yup";
import Input from "../../Input";
import Button from "../../Button";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { addDetail } from "../../../hooks/addDetail";
import { TIME_INFO, TIME_RESULT } from "../../../utils/notifications/time";

const StepTwo = ({
    setStep,
    data
}: IStep) => {
    const [amount, setAmount] = useState("")
    const STEP_ADD_IMAGE_PRODUCT = 3
    const formValidationWithYup = Yup.object().shape({
        details: Yup.string().required(),
        amount: Yup.string().required(),
    })

    return (
        <div>
            <Formik
                initialValues={{
                    details: "",
                    amount: "",
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    if(data) {
                        const { isError } = await addDetail(values, data)
                        
                        if(isError) {
                            toastUpdate("submitVar", "error", TIME_RESULT, "Falha ao criar variação. Tente novamente ou contate o suporte")
                        }

                        else {
                            setStep && setStep(STEP_ADD_IMAGE_PRODUCT)
                        }
                    }
                }}
            >
                {({initialValues, errors, dirty, isValid, touched}) => {
                    initialValues.amount = (parseInt(data?.amount!) / 100).toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2});
                    
                    return (
                        <Form>
                                <TitleField>
                                    Inserir variação inicial
                                </TitleField>
                            <RowForInput>
                                <InputContainer>
                                    <Field 
                                        name="details" 
                                        isError={errors.details && touched.details}
                                        type="text" 
                                        maxLength={25}
                                        placeholder="Nome da variação, exemplo: Tamanho P"
                                        as={Input}
                                    />
                                </InputContainer>
                                <InputContainer>
                                    <Field 
                                        name="amount" 
                                        type="string"
                                        isError={errors.amount && touched.amount}
                                        onChange={(e: any) => {
                                            setAmount(e.target.value);
                                        }}
                                        value={amount}
                                        placeholder="Preço da variação"
                                        as={Input}
                                    />
                                </InputContainer>
                            </RowForInput>
                            <RowForButton>
                                <ButtonContainer>
                                    <Button 
                                        onClick={() => {
                                            toastCreate(
                                                "submitVar", 
                                                "info", 
                                                TIME_INFO, 
                                                "Processando"
                                            )
                                        }} 
                                        disabled={ !(dirty && isValid)}
                                        type="submit">
                                            Adicionar Variação
                                    </Button>
                                </ButtonContainer>
                            </RowForButton>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default StepTwo